import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 surface-100 border-round-xl" }
const _hoisted_2 = { class: "flex align-items-center>" }
const _hoisted_3 = { class: "flex gap-2" }
const _hoisted_4 = { class: "p-2 border-round bg-white" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "p-2 border-round bg-white" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "p-2 border-round bg-white" }
const _hoisted_9 = ["textContent"]

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useReviewReportStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewReportStudents',
  setup(__props) {

const { students } = storeToRefs(useReviewReportStore());

const total = computed(() => new Intl.NumberFormat().format(students.value.data.total || 0));

const active = computed(() => new Intl.NumberFormat().format(students.value.data.active || 0));

const inactive = computed(() => new Intl.NumberFormat().format(students.value.data.inactive || 0));

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "flex-1 text-base text-color-secondary mb-2" }, "Students", -1)),
      _withDirectives(_createVNode(_component_Icon, {
        name: "info",
        class: "text-gray-400 text-base cursor-pointer"
      }, null, 512), [
        [
          _directive_tooltip,
          
          'Total: all students with scheduled events. Active: students with scheduled events and active services. Inactive: students with scheduled events but no active services.'
        ,
          void 0,
          { left: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-color-gray text-sm" }, "Total", -1)),
        (_unref(students).loading)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "1rem",
              class: "mt-1"
            }))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "text-color-green text-lg font-bold",
              textContent: _toDisplayString(total.value)
            }, null, 8, _hoisted_5))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-color-gray text-sm" }, "Active", -1)),
        (_unref(students).loading)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "1rem",
              class: "mt-1"
            }))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "text-color-blue text-lg font-bold",
              textContent: _toDisplayString(active.value)
            }, null, 8, _hoisted_7))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-color-gray text-sm" }, "Inactive", -1)),
        (_unref(students).loading)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "1rem",
              class: "mt-1"
            }))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "text-color-orange text-lg font-bold",
              textContent: _toDisplayString(inactive.value)
            }, null, 8, _hoisted_9))
      ])
    ])
  ]))
}
}

})